<template>
    <div>
        <v-row v-masonry>
            <v-col cols="12" sm="6" lg="4">
                <v-card class="soli-round" :disabled="disablePreferences">
                    <v-container>
                        <v-card-title class="soli-grey"
                            >Notifications</v-card-title
                        >
                        <v-card-subtitle class="soli-grey">
                            Manage how you receive notifications
                        </v-card-subtitle>
                        <v-card-text v-if="user.email" class="px-0 soli-grey">
                            <NotificationPreferencesForm
                                v-model="form.notification_preferences"
                                :rules="rules"
                            />
                        </v-card-text>
                    </v-container> </v-card
            ></v-col>
            <v-col
                cols="12"
                sm="6"
                lg="4"
                v-if="user.email && can('Sync calendar')"
            >
                <v-card class="soli-round" :disabled="disablePreferences">
                    <v-container>
                        <v-card-title class="soli-grey"
                            >Connections</v-card-title
                        >
                        <v-card-subtitle class="soli-grey pb-0"
                            >Subscribe to notifications and
                            calendars</v-card-subtitle
                        >
                        <div
                            class="absolute top-7 right-6"
                            v-if="
                                false
                                //$page.props.auth.user.id == user.id
                            "
                        >
                            <!--<div id="googleSignIn"></div>-->
                            <v-btn
                                :loading="loading"
                                v-if="!user.google_calendar_id"
                                small
                                rounded
                                outlined
                                color="dark"
                                @click="syncGoogle()"
                                ><v-img
                                    class="mr-1"
                                    width="18"
                                    :src="'/google.png'"
                                />Sync Calendar</v-btn
                            >
                            <v-btn
                                v-if="user.google_calendar_id"
                                small
                                rounded
                                outlined
                                color="dark"
                                @click="confirmCalendarSync = true"
                                ><v-img
                                    class="mr-1"
                                    width="18"
                                    :src="'/google.png'"
                                />Remove Calendar</v-btn
                            >
                        </div>
                        <v-row>
                            <v-col>
                                <v-list class="pt-0" dense>
                                    <v-list-item
                                        v-for="(
                                            relationship, i
                                        ) in relationships"
                                        :key="relationship.id"
                                    >
                                        <v-switch
                                            :label="relationship.name"
                                            v-model="
                                                form.syncRelationships[i]
                                                    .email_updates
                                            "
                                            hide-details
                                        />
                                    </v-list-item>
                                </v-list>
                            </v-col> </v-row></v-container
                ></v-card>
            </v-col>
            <v-col cols="12" sm="6" lg="4" v-if="user.email">
                <v-card class="soli-round" :disabled="disablePreferences">
                    <v-container>
                        <v-card-title class="soli-grey">
                            Settings
                        </v-card-title>
                        <v-card-subtitle class="caption"> </v-card-subtitle>
                        <v-row>
                            <v-col>
                                <v-list>
                                    <v-list-item>
                                        <v-combobox
                                            :items="timezones"
                                            v-model="form.timezone"
                                            label="Timezone"
                                            prepend-inner-icon="watch"
                                            outlined
                                            :rules="rules.input"
                                            dense
                                            :menu-props="{
                                                closeOnContentClick: true,
                                            }"
                                        >
                                            <template v-slot:prepend-item>
                                                <v-list-item
                                                    ripple
                                                    @click="
                                                        form.timezone = guessTZ
                                                    "
                                                >
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Recommended:
                                                            {{ guessTZ }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider
                                                    class="mt-2"
                                                ></v-divider>
                                            </template>
                                        </v-combobox>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <SoliChoice
            v-if="confirmCalendarSync"
            ref="calendarSync"
            @reset="closeCalendarSync"
            title="Are you sure?"
            :subtitle="'This will remove your lessons from Google Calendar'"
            button1="Confirm"
            button2="Nevermind"
            loading1
            @option1="deleteCalendar()"
        ></SoliChoice>
    </div>
</template>

<script>
import NotificationPreferencesForm from "./NotificationPreferencesForm.vue";

export default {
    name: "UserPreferences",
    props: {
        user: {
            type: Object,
            required: true,
        },
        notificationPreferences: {
            type: Object,
            default: () => ({}),
        },
        errors: {},
        relationships: {
            type: Array,
            default: () => [],
        },
        rules: {},
    },
    components: {
        NotificationPreferencesForm,
    },
    data: function () {
        return {
            editing: false,
            loading: false,
            confirmCalendarSync: false,
            googleClient: null,
            form: {
                syncRelationships: this.relationships.map((e) => {
                    return {
                        id: e.pivot.id,
                        email_updates: e.pivot.email_updates,
                    };
                }),
                notification_preferences: JSON.parse(
                    JSON.stringify(this.notificationPreferences)
                ),
                timezone: this.user.timezone,
            },
        };
    },
    computed: {
        disablePreferences() {
            return (
                this.$page.props.auth.user.id !== this.user.id &&
                !this.is("Admin")
            );
        },
        guessTZ() {
            return moment.tz.guess();
        },
        timezones() {
            return moment.tz.zonesForCountry("US").includes(this.guessTZ)
                ? moment.tz.zonesForCountry("US")
                : moment.tz.names();
        },
    },
    methods: {
        syncGoogle() {
            this.googleClient.requestCode();
        },
        syncCalendar(authResp) {
            if (!authResp) return;
            this.loading = true;
            this.$inertia.post(
                route("google-calendar.store", {
                    user_id: this.user.id,
                    code: authResp.code,
                }),
                {},
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit("success");
                        this.loading = false;
                    },
                    onError: (errors) => {
                        this.loading = false;
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                    },
                }
            );
        },
        deleteCalendar() {
            this.$inertia.put(
                route("google-calendar.update", this.user.google_calendar_id),
                {},
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit("success");
                        this.$refs.calendarSync.reset();
                    },
                    onError: (errors) => {
                        this.$refs.calendarSync.reset();
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                    },
                }
            );
        },
        closeCalendarSync() {
            setTimeout(() => {
                this.confirmCalendarSync = false;
            }, 300);
        },
        save() {
            this.$emit("submit");
            this.$inertia.put(
                `/users/${this.user.id}/update-preferences`,
                this.form,
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        this.$emit("success");
                        this.editing = false;
                        this.formCopy = JSON.stringify(this.form);
                        this.$emit("reset");
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.$emit("reset");
                    },
                }
            );
        },
        loadGoogleAuth() {
            // render google login button
            const clientId = window.location.href.includes("musicologie.app")
                ? "638179707569-qurekcejldl1581s3iie2r3plk1sqooj.apps.googleusercontent.com"
                : "913942240028-2fnj67d0a8h6mhn7j5q8vaged5m6pgf2.apps.googleusercontent.com";

            this.googleClient = google.accounts.oauth2.initCodeClient({
                client_id: clientId,
                scope: "https://www.googleapis.com/auth/calendar",
                ux_mode: "popup",
                callback: (response) => {
                    this.syncCalendar(response);
                },
            });
        },
    },
    mounted() {
        this.formCopy = JSON.stringify(this.form);
        this.$loadScript("https://accounts.google.com/gsi/client").then(() => {
            this.loadGoogleAuth();
        });
    },
    updated() {
        setTimeout(() => {
            this.$redrawVueMasonry();
        }, 300);
    },
    beforeDestroy() {
        this.$emit("editing", false);
    },
    watch: {
        form: {
            handler: function (val) {
                if (JSON.stringify(val) == this.formCopy) {
                    this.editing = false;
                } else {
                    this.editing = true;
                }
            },
            deep: true,
        },
        editing(editing) {
            this.$emit("editing", editing);
        },
    },
};
</script>
